import { c as _c } from "react/compiler-runtime";
import type { DocumentUpload } from '@onefootprint/request-types/dashboard';
import { forwardRef } from 'react';
import type { EntityVault } from '@/types/vault';
import type { Rotation } from '@/utils/rotation';
import { getUploadKey } from '../../utils/get-doc-upload-key';
import UploadTitleCard from '../upload-title-card';
import PdfThumbnail from './components/pdf-thumbnail';
import UploadImage from './components/upload-image';
import useUploadData from './hooks/use-upload-data/use-upload-data';
type UploadImageItemProps = {
  upload: DocumentUpload & {
    isLatest: boolean;
  };
  vault: EntityVault;
  imageOnly?: boolean;
  rotateIndex?: number;
  rotation?: Rotation;
  onRotate?: () => void;
};
const UploadImageItem = forwardRef<HTMLDivElement, UploadImageItemProps>((t0, ref) => {
  const $ = _c(12);
  const {
    upload,
    vault,
    imageOnly,
    rotateIndex,
    rotation,
    onRotate
  } = t0;
  const {
    objectUrl,
    isPdf
  } = useUploadData(upload, vault);
  if (!objectUrl) {
    return null;
  }
  if (isPdf) {
    let t1;
    if ($[0] !== objectUrl) {
      t1 = <PdfThumbnail src={objectUrl} />;
      $[0] = objectUrl;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== imageOnly || $[3] !== objectUrl || $[4] !== onRotate || $[5] !== rotateIndex || $[6] !== rotation || $[7] !== upload) {
    t1 = imageOnly ? <UploadImage objectUrl={objectUrl} alt={getUploadKey(upload)} failureReasons={upload.failureReasons} rotateIndex={rotateIndex} rotation={rotation} /> : <><UploadTitleCard upload={upload} onRotate={onRotate} /><UploadImage objectUrl={objectUrl} alt={getUploadKey(upload)} failureReasons={upload.failureReasons} rotateIndex={rotateIndex} rotation={rotation} /></>;
    $[2] = imageOnly;
    $[3] = objectUrl;
    $[4] = onRotate;
    $[5] = rotateIndex;
    $[6] = rotation;
    $[7] = upload;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== ref || $[10] !== t1) {
    t2 = <div className="flex flex-col items-center w-full gap-2 scroll-mt-2" ref={ref}>{t1}</div>;
    $[9] = ref;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
});
export default UploadImageItem;